export default "__VITE_ASSET__C3XHTwtt__"